<!--
 * @Author: your name
 * @Date: 2022-03-17 13:33:49
 * @LastEditTime: 2022-03-24 16:45:44
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Do-network\src\components\pc\Blog-fooret.vue
-->
<template>
  <div>
    <div class="Blog-footer">
      <div class="Blog-footer-title">
        <p>{{ $t("Blog.join") }}</p>
      </div>
      <div class="Blog-footer-title-p">
        <p>
          {{ $t("Blog.detail1") }}
        </p>
      </div>
      <div class="clearfix">
        <el-form
          ref="emailForm"
          :model="emailForm"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item prop="mailAddress">
            <el-input
              placeholder="Enter your email address"
              v-model="emailForm.mailAddress"
              @blur="sendEmail"
            ></el-input>
            <el-button @click="Blogbtn">{{ $t("Blog.subscribe")}}</el-button>
          </el-form-item>
        </el-form>
        <div>{{blogIaad}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { SubBlog } from "@/assets/server/api.js";
export default {
  props:["blogIaad"],
  data() {
    return {
      emailForm: {
        mailAddress: null,
      },
      rules: {
        mailAddress: [
          { required: true, message: "Enter your email address", trigger: "change" },
        ],
      },
      email:"",
      // id:this.blogId
    };
  },
  methods: {
    async Blogbtn() {
      let id = obj.blogId;
      let info = id + "/" + this.email;
      // this.blogId = id +"/"+this.email;
      // let email1 = this.email;
      this.data = await SubBlog(info);
      // this.id = localStorage.getItem("id");
      // this.email = localStorage.getItem("email");
      // let email1 = this.email;
      // let blogId = this.id
      // console.log("id",this.id);
      // await SubBlog(blogId,email1)

    },
    sendEmail() {
      var regEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (
        this.emailForm.mailAddress != "" &&
        !regEmail.test(this.emailForm.mailAddress)
      ) {
        this.$message({
          message: "The mailbox format is incorrect",
          type: "error",
        });
        this.emailForm.mailAddress = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.Blog-footer {
  box-sizing: border-box;
  width: 100%;
  height: 260px;
  background: rgba(69, 115, 231, 0.03);
  border-top: 2px solid #4573e7;
  padding: 48px 50px 59px 50px;
  margin-bottom: 289px;
  .Blog-footer-title {
    font-size: 20px;
    font-weight: bold;
    color: #000;
    line-height: 23px;
    margin-left: 10px;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Bold, Microsoft YaHei;
  }
  .Blog-footer-title-p {
    font-size: 14px;
    color: #4573e7;
    font-weight: 400;
    line-height: 20px;
    margin: 15px 0 40px 10px;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
  }
  .el-form /deep/ .el-form-item{
    .el-form-item__content{
      margin-left: 0 !important;
    }

  }
  .el-input{
    width: 840px;
    height: 50px;
    float: left;
  }
  .el-input /deep/ input{
    width: 840px;
    height: 50px;
    border: 2px solid #767676;
    float: left;
    font-size: 14px;
    padding: 14px 30px 15px 30px;
    border-radius: 30px;
    color: #999;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
    outline: none;
    box-sizing: border-box;
  }
  // input {
  //   float: left;
  //   width: 840px;
  //   height: 50px;
  //   font-size: 14px;
  //   padding: 14px 30px 15px 30px;
  //   border-radius: 30px;
  //   border: 2px solid #767676;
  //   color: #999;
  //   -webkit-background-clip: text;
  //   font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
  //   outline: none;
  //   box-sizing: border-box;
  // }
  button {
    float: left;
    border-radius: 31px;
    height: 50px;
    border: 2px solid #4573e7;
    padding: 14px 56px 15px 56px;
    color: #4573e7;
    font-size: 16px;
    font-weight: 400;
    -webkit-background-clip: text;
    font-family: Microsoft YaiHei-Regular, Microsoft YaHei;
    margin-left: 61px;
    box-sizing: border-box;
  }
}
</style>
